module.exports = __webpack_public_path__ + "static/media/antartica.f27d7fc8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/antartica.jpg
// module id = 108
// module chunks = 0